<template>
    <b-container fluid>
        <b-form-row class="annc-update-header mb-3 mt-2 pt-2">
            <b-col>
                <div>
                    Editing Announcement # {{ form.announcement_id }}
                </div>
            </b-col>
            <b-col cols="2">
                <v-button prevent-default
                          aria-hidden="true"
                          class="btn-sm delete-button mb-2"
                          type="delete"
                          @click="deleteThisAnnouncement(form)"
                >
                    <fa-icon :icon="saveButtonOptions.icon" />
                    <strong> DELETE</strong>
                </v-button>
            </b-col>
        </b-form-row>
        <b-form>
            <b-form-group
                horizontal
                label="Created by: "
                label-cols="0"
                label-cols-sm="2"
                label-align-sm="right"
            >
                <b-form-input
                    id="created-by"
                    :value="authorInfo()"
                    plaintext
                    type="text"
                />
            </b-form-group>

            <b-form-group
                horizontal
                label="Message Text:"
                label-for="message-text"
                label-cols="0"
                label-cols-sm="2"
                label-align-sm="right"
            >
                <b-form-textarea
                    id="message-text"
                    :value="form.message_text"
                    placeholder="Enter announcement text..."
                    rows="3"
                    max-rows="6"
                />
            </b-form-group>

            <b-form-group
                horizontal
                label="Message Color:"
                label-for="variant"
                label-cols="0"
                label-cols-sm="2"
                label-align-sm="right"
            >
                <b-form-select
                    id="variant"
                    v-model="form.variant"
                    :options="variants"
                />
            </b-form-group>

            <!--
            <b-form-group
                horizontal
                label="Status:"
                label-cols="0"
                label-cols-sm="2"
                label-align-sm="right"
            >
                <b-form-row>
                    <b-col cols="auto">
                        <b-form-input
                            id="form-active-status"
                            :value="form.active ? 'Active' : 'Inactive'"
                            plaintext
                            type="text"
                            :class="form.active ? 'active-status' : 'inactive-status'"
                        />
                    </b-col>
                    <b-col>
                        <span class="text-left">
                            <v-button prevent-default
                                      aria-hidden="true"
                                      class="btn-sm"
                                      tabindex="2"
                                      :type="saveButtonOptions.type"
                                      @click="toggleUserStatus"
                            >
                                <fa-icon :icon="saveButtonOptions.icon" />
                                {{ saveButtonOptions.text }}
                            </v-button>
                        </span>
                    </b-col>
                </b-form-row>
            </b-form-group>
            -->

            <b-row>
                <v-button
                    class="mt-3"
                    prevent-default
                    aria-hidden="true"
                    @click="submitChanges"
                >
                    Save
                </v-button>
            </b-row>
        </b-form>
    </b-container>
</template>


<script>
// import { alertManager } from '~/plugins/alertManager';
import { mapGetters } from 'vuex';

export default {
    name: 'AnnouncementUpdate',

    props: {
        announcementId: { type: Number, default: null },
    },

    data() {
        const now = new Date();
        const today = Date(now.getFullYear(), now.getMonth(), now.getDay());

        const variants = [
            { value: null, text: 'Please select an option' },
            { value: 'primary', text: 'Purple' },
            { value: 'success', text: 'Green' },
            { value: 'warning', text: 'Yellow' },
            { value: 'danger', text: 'Red' },
            { value: 'info', text: 'Blue' },
            { value: 'light', text: 'White' },
            { value: 'secondary', text: 'Light Gray' },
            { value: 'dark', text: 'Dark Gray' }
        ];


        const emptyAnnouncement = {
            message_text: null,
            variant: 'primary',
            active: true,
            author_id: null,
        };

        return {
            form: {
                ...emptyAnnouncement,
            },
            announcement_id: this.announcementId,
            author: null,
            today,
            variants,
        };
    },

    computed: {
        ...mapGetters({
            authUser: 'auth/authUser',
        }),

        saveButtonOptions() {
            if (this.form.active) {
                return {
                    type: 'primary',
                    icon: 'power-off',
                    text: 'Make Announcement Inactive',
                };
            }

            return {
                type: 'secondary',
                icon: 'power-off',
                text: 'Make Announcement Active',
            };
        },
    },

    async created() {
        this.author = await this.authUser;
        this.form = await this.$store.dispatch('announcement/fetchAnnouncement', this.announcementId);
    },

    methods: {
        async submitChanges() {
            await this.$store.dispatch(
                'announcement/saveAnnouncement',
                this.form);
        //     this.form = { ...this.emptyAnnouncement };
        //     this.author = null;
        },

        async deleteThisAnnouncement(payload) {
            await this.$store.dispatch(
                'announcement/removeAnnouncement',
                payload);
            this.$router.push({ name: 'admin.announcements.AnnouncementList' });
        },

        authorInfo() {
            return this.author !== null
                ? this.author.fname + ' ' + this.author.lname + '    ' + this.author.email : '';
        },

        async toggleUserStatus() {
            this.form.active = !this.form.active;
        },
    },
};
</script>

<style lang="scss">
@import '$StyleVars';

.annc-update-header {
    font-size: 1.5rem;
    font-weight: bolder;
    color: white;
    background-color: $ace-purple;
}

.delete-button {
    background-color: white;
    color:$delete-button-color;

    &:hover {
            color: $white;
            background-color: scale_color($delete-button-color, $alpha: 8%);
            border-color: $delete-button-color;
        }
}

.active-status {
    color: $ace-green;
    font-weight: bolder;
}

.inactive-status {
    color: $ace-red;
    font-weight: bolder;
}
</style>
